import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Work from './pages/Work';
import ProjectDetail from './pages/ProjectDetail';
import './App.css'; // We'll rely on index.css mostly but keep this if needed, or clear it.

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <LanguageProvider>
          <Router>
            <div className="app-container">
              <Sidebar />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/work" element={<Work />} />
                  <Route path="/project/:id" element={<ProjectDetail />} />
                </Routes>
              </main>
            </div>
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
